/* Tidel: animated progress dots for the hero slideshow. Not part of Ella.

   Drives one CSS custom property, --hero-dot-progress (0 → 1), on the active
   pagination bullet. The value comes straight from Swiper's own autoplay clock
   via the `autoplayTimeLeft` event, so the fill can never drift out of sync with
   the real slide timing and the duration is always whatever the section's
   "Seconds per slide" setting produced — nothing is timed or hardcoded here.

   Swiper 12 emits autoplayTimeLeft(swiper, timeLeftMs, fractionRemaining) on
   every animation frame, and:
     - stops emitting entirely when autoplay is not running, and
     - freezes fractionRemaining while autoplay is paused (pauseOnMouseEnter),
   which gives us "pauses on hover" and "no fill when autoplay is off" for free.

   Markup is untouched, so Swiper's clickable bullets and their role / tabindex /
   aria-label stay exactly as Swiper wrote them. */
(function () {
  'use strict';

  var HERO = '.hero-main';
  var DOTS = '.hero-main__dots';
  var BULLET = '.swiper-pagination-bullet';
  var ACTIVE = '.swiper-pagination-bullet-active';
  var FLAG = 'tidelHeroDots';
  var PROP = '--hero-dot-progress';

  function attach(component) {
    var swiper = component.initSwiper;
    if (!swiper) return false; // not initialised yet

    component.dataset[FLAG] = '1';
    var pagination = component.querySelector(DOTS);
    if (!pagination) return true;

    function paint(fraction) {
      var bullets = pagination.querySelectorAll(BULLET);
      for (var i = 0; i < bullets.length; i++) {
        var bullet = bullets[i];
        if (bullet.matches(ACTIVE)) {
          bullet.style.setProperty(PROP, fraction.toFixed(4));
        } else {
          bullet.style.removeProperty(PROP);
        }
      }
    }

    function autoplayRunning() {
      return !!(swiper.autoplay && swiper.autoplay.running);
    }

    /* With autoplay off there is no clock to show, so the pill reads as simply
       highlighted: fill it completely rather than leaving a dark empty track. */
    function rest() {
      paint(autoplayRunning() ? 0 : 1);
    }

    swiper.on('autoplayTimeLeft', function (_s, _time, remaining) {
      paint(1 - remaining);
    });

    swiper.on('slideChange', rest);
    swiper.on('autoplayStart', function () {
      paint(0);
    });
    swiper.on('autoplayStop', function () {
      paint(1);
    });

    rest();
    return true;
  }

  function boot() {
    var heroes = document.querySelectorAll(HERO + ' swiper-component');
    var pending = false;

    for (var i = 0; i < heroes.length; i++) {
      var component = heroes[i];
      if (component.dataset[FLAG]) continue;
      if (!attach(component)) pending = true;
    }
    return !pending;
  }

  /* <swiper-component> initialises lazily (deferUntilInteraction + inView), so
     poll briefly until the instance exists, then stop. */
  function bootWithRetry() {
    if (boot()) return;
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (boot() || tries > 100) window.clearInterval(timer);
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootWithRetry, { once: true });
  } else {
    bootWithRetry();
  }

  document.addEventListener('shopify:section:load', bootWithRetry);
})();
